export enum FeaturesEvents {
    pinReportAdded = 'features:pinReportAdded',
    featuresAdded = 'featuresAdded',
    featuresEdited = 'featuresEdited',
    featureRemoved = 'featureRemoved',
    featuresBackToStart = 'features:backToStart',
    hideReport = 'features:hideReport',
    reportChanged = 'reportChanged',
}